import config from './config.json';

export const paths = config.paths;
export const text = config.text;
export const contact = config.contact;
export const socialLinks = config.socialLinks;
